import { FC, PropsWithChildren, useMemo, useState } from 'react';
import { FormAutoComplete } from '../common/form';
import styled from 'styled-components';

export interface GroupCodeFormAutoCompleteProps {
  name: string;
  groupCodes: string[];
}

export const GroupCodeFormAutoComplete: FC<
  PropsWithChildren<GroupCodeFormAutoCompleteProps>
> = (props) => {
  const { name, groupCodes } = props;
  const [searchTerm, setSearchTerm] = useState('');

  const options = useMemo(
    () =>
      groupCodes
        .filter((code) => code.includes(searchTerm))
        .map((code) => ({ label: code, value: code })),
    [groupCodes, searchTerm],
  );

  return (
    <StyledFormAutoComplete
      name={name}
      options={options}
      onSearch={setSearchTerm}
    />
  );
};

const StyledFormAutoComplete = styled(FormAutoComplete)`
  min-width: 7rem;
`;
